import React, { useState, useEffect } from "react";
const SearchableDropdown = ({
  options,
  onSelect,
  defaultValue = "",
  name,
  className,
  disabled=false
}) => {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    setInputValue(defaultValue);
    onSelect(defaultValue);
  }, [defaultValue]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowDropdown(true);

    const filtered = options.filter((opt) =>
      opt.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered);

    onSelect(value);
  };

  const handleOptionClick = (option) => {
    setInputValue(option);
    setShowDropdown(false);
    onSelect(option);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 100);
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type="text"
        name={name} // 👈 use passed name
        className={className} // 👈 use passed className
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setShowDropdown(true)}
        onBlur={handleBlur}
        placeholder="Type or select..."
        style={{
          width: "100%",
          padding: "8px",
        }}
        disabled={disabled}
      />

      {showDropdown && filteredOptions.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#ffffff",
            border: "1px solid #c2e6d1",
            borderRadius: "10px",
            listStyle: "none",
            margin: 0,
            padding: 0,
            maxHeight: "150px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          {filteredOptions.map((option, idx) => (
            <li
              key={idx}
              onMouseDown={() => handleOptionClick(option)}
              style={{
                padding: "8px",
                cursor: "pointer",
                fontSize: "13px", 
                color: "#4d6d64", 
              }}
              onMouseEnter={
                (e) => (e.currentTarget.style.backgroundColor = "#f4faf5") 
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchableDropdown;
